import {Linking, Platform} from 'react-native';

export const dial = (number: string) => Linking.openURL(`tel:${number}`);

export const sendSms = (number: string, sms = '') =>
  Linking.openURL(
    Platform.OS === 'ios'
      ? `sms:${number}&body=${sms}`
      : `sms:${number}?body=${sms}`,
  );
